import React from "react";
import { Alert, LinearProgress, Paper, Stack, Typography } from "@mui/material";
import SupplierGroupList from "./SupplierGroupList";

const SupplierContent = ({
    error,
    loading,
    hasResults,
    groups,
    onClearError,
    onEdit,
    onDelete,
}) => (
    <Stack spacing={3}>
        {error && (
            <Alert severity="error" onClose={onClearError}>
                {error}
            </Alert>
        )}

        {loading && <LinearProgress />}

        {!loading && !hasResults && (
            <Paper
                variant="outlined"
                sx={{
                    borderStyle: "dashed",
                    borderRadius: 3,
                    p: 4,
                    textAlign: "center",
                    color: "text.secondary",
                }}
            >
                <Typography variant="subtitle1" fontWeight={600}>
                    Noch keine Lieferanten vorhanden
                </Typography>
                <Typography variant="body2" sx={{ mt: 1 }}>
                    Lege einen neuen Lieferanten an, um ihn später bei Ausgaben auszuwählen.
                </Typography>
            </Paper>
        )}

        {!loading && !error && hasResults && (
            <SupplierGroupList groups={groups} onEdit={onEdit} onDelete={onDelete} />
        )}
    </Stack>
);

export default SupplierContent;
